import styled from 'styled-components';

const JobEventLineNumber = styled.div`
  color: var(--pf-v6-global--Color--200);
  flex: 0 0 45px;
  text-align: right;
  vertical-align: top;
  padding-right: 5px;
  user-select: none;
`;

JobEventLineNumber.displayName = 'JobEventLineNumber';

export default JobEventLineNumber;
